import { useState, useEffect } from 'react';
import ShipmentService from '../services/shipment.service';
import { Truck, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const ShipmentPage = () => {
    const [shipments, setShipments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchShipments();
    }, []);

    const fetchShipments = async () => {
        try {
            const response = await ShipmentService.getShipments();
            setShipments(response.data.results || []);
        } catch (error) {
            console.error("Failed to load shipments", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl font-bold mb-8">Shipments</h1>

            {loading ? <div>Loading...</div> : (
                <div className="space-y-6">
                    {shipments.map(shipment => (
                        <div key={shipment.id} className="bg-white p-6 rounded-2xl border border-zinc-100 shadow-sm">
                            <div className="flex justify-between items-start mb-6">
                                <div>
                                    <div className="font-bold text-lg flex items-center gap-2 mb-1">
                                        <Truck className="text-blue-600" size={20} />
                                        {shipment.tracking_number}
                                    </div>
                                    <div className="text-zinc-500 text-sm">Carrier: {shipment.carrier}</div>
                                </div>
                                <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase ${shipment.status === 'delivered' ? 'bg-green-100 text-green-700' :
                                        shipment.status === 'pending' ? 'bg-zinc-100 text-zinc-700' : 'bg-blue-100 text-blue-700'
                                    }`}>
                                    {shipment.status}
                                </span>
                            </div>

                            {/* Tracking History Preview */}
                            {shipment.tracking_history && shipment.tracking_history.length > 0 ? (
                                <div className="border-l-2 border-zinc-100 ml-2 pl-6 space-y-6 relative">
                                    {shipment.tracking_history.slice(0, 3).map((track, idx) => (
                                        <div key={track.id} className="relative">
                                            {/* Dot */}
                                            <div className="absolute -left-[31px] top-1 w-3 h-3 bg-zinc-200 rounded-full border-2 border-white ring-1 ring-zinc-50"></div>

                                            <div className="flex flex-col sm:flex-row sm:justify-between gap-1">
                                                <div className="font-medium text-sm text-zinc-900">{track.status}</div>
                                                <div className="text-xs text-zinc-400">{new Date(track.timestamp).toLocaleString()}</div>
                                            </div>
                                            <div className="text-sm text-zinc-500 mt-1 flex items-start gap-1">
                                                <MapPin size={14} className="mt-0.5 flex-shrink-0" /> {track.location} - {track.description}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="text-zinc-400 text-sm italic pl-2">No tracking updates yet.</div>
                            )}

                            <div className="mt-6 pt-4 border-t border-zinc-100 flex justify-end">
                                <Link to={`/orders/${shipment.order}`} className="text-sm font-bold text-blue-600 hover:text-blue-800">
                                    View Order
                                </Link>
                            </div>
                        </div>
                    ))}

                    {shipments.length === 0 && (
                        <div className="p-12 text-center text-zinc-500 border border-zinc-100 rounded-3xl bg-white">
                            <Truck size={48} className="mx-auto mb-4 text-zinc-300" />
                            No shipments found.
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ShipmentPage;
